export default __webpack_public_path__ + "media/images/svg/forest-green-caret.svg";